import type React from 'react';
import { type ModalContentProps } from '../state';
import {
  DemoModal,
  DeleteEventModal,
  CreateMemberModal,
  InviteMemberModal,
  ViewMemberModal,
  DeleteMemberModal,
  EditIncidentModal,
  EditEventModal,
  EmbedEventModal,
  FileUploadModal,
} from './modals';

const Noop = () => null;

const MODALS: Record<string, React.FC<ModalContentProps>> = {
  demo: DemoModal,
  deleteEvent: DeleteEventModal,
  createMember: CreateMemberModal,
  inviteMember: InviteMemberModal,
  viewMember: ViewMemberModal,
  deleteMember: DeleteMemberModal,
  editIncident: EditIncidentModal,
  editEvent: EditEventModal,
  embedEvent: EmbedEventModal,
  fileUpload: FileUploadModal,
};

export const getModalContent = (
  modalType: string | null,
): React.FC<ModalContentProps> => MODALS[modalType || ''] || Noop;
